import { render, staticRenderFns } from "./Awning.vue?vue&type=template&id=7270bbde&scoped=true"
import script from "./Awning.vue?vue&type=script&lang=ts"
export * from "./Awning.vue?vue&type=script&lang=ts"
import style0 from "./Awning.vue?vue&type=style&index=0&id=7270bbde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270bbde",
  null
  
)

export default component.exports